import React, { useState } from 'react';
import { useSubmit, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Navbar, Container, Button, Nav, Image, Badge, Stack, Dropdown } from 'react-bootstrap';
import { FaRegCommentDots } from "react-icons/fa";
import { TbGridDots } from 'react-icons/tb';
import GetHeaderButtonByName from './HeaderButtons';
// import ChatSideModal from '../chat/ChatSideModal';
import ModulesSideModal from '../modulesModal/ModulesSideModal';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const submit = useSubmit();

    const rtl = useSelector(state => state.lc.rtl);
    const langShortcut = useSelector(state => state.lc.lang);
    const lang = useSelector(state => state.lang[langShortcut]);
    const user = useSelector(state => state.auth.user);
    const sortedButtons = useSelector(state => state.header.sortedButtons);

    // const [showChatSideModal, setShowChatSideModal] = useState(false);
    const [showModulesSideModal, setShowModulesSideModal] = useState(false);

    const handleLogout = () => {
        submit(null, { method: "post", action: "/sys/logout" });
    }

    const userProfileToggle = React.forwardRef(({ children, onClick }, ref) => (
        <div ref={ref} onClick={(e) => { e.preventDefault(); onClick(e); }}>
            {children}
        </div>
    ));

    return (
        <>
            <Navbar expand="lg" className="header">
                <Container fluid>
                    <div style={{ width: '98px', textAlign: 'center' }}>
                        <Button
                            variant="outline-secondary icon-button"
                            style={{ marginInlineStart: '3px' }}
                            onClick={(e) => { setShowModulesSideModal(true) }}
                        >
                            <TbGridDots className="grid-dots-icon" />
                        </Button>
                    </div>
                    <Navbar.Brand href="#" style={{ marginInlineStart: 'var(--bs-navbar-brand-margin-end)' }}>
                        <Image height='45' src="/images/floworglogo.png" alt="Logo" /> <span style={{color: '#ecc383'}}>{user.workspaceName}</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll" style={{ gap: '0px' }}>
                        <Nav
                            className="my-2 my-lg-0"
                            style={{ alignItems: 'center', marginInlineStart: 'auto' }}
                            navbarScroll
                        >
                            {sortedButtons.map((bName, index) => {
                                return <GetHeaderButtonByName key={'button-' + index} name={bName} index={index} />
                            })}
                            <Dropdown style={{ marginInlineStart: '1rem' }}>
                                <Dropdown.Toggle as={userProfileToggle}>
                                    <Stack className="user-profile-toggle" direction="horizontal">
                                        <div><Image src={user.profileImage || '/images/userProfileImage.png'} title={user.name} alt="Profile Image" className="rounded-circle user-profile-image" /></div>
                                        <div>
                                            <Stack direction="vertical">
                                                <div className="user-name">{user.name}</div>
                                            </Stack>
                                        </div>
                                    </Stack>
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ textAlign: (rtl ? 'right' : 'left'), fontSize: '12px' }}>
                                    <Dropdown.Item eventKey="1" onClick={() => { navigate('/sys/settings'); }}>{lang['Header'].Settings}</Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item eventKey="2" onClick={handleLogout}>{lang['Header'].Logout}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>

                        <div className="chat-btn-box">
                            <Button
                                variant="outline-secondary chat-icon-button pos-rel"
                                // onClick={(e) => { setShowChatSideModal(true) }}
                            >
                                <div><FaRegCommentDots /></div>
                                <Badge bg="" className="my-badge">2</Badge>
                            </Button>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* <ChatSideModal show={showChatSideModal} setShow={setShowChatSideModal} /> */}
            <ModulesSideModal show={showModulesSideModal} setShow={setShowModulesSideModal} />
        </>
    );
};

export default Header;
